import {ErrorHandler, isDevMode, Injectable} from '@angular/core';
import {Notifier} from '@airbrake/browser';
import {environment} from '@environments/environment';
import {SettingsService} from './settings.service';

@Injectable()
export class AirbrakeErrorHandler implements ErrorHandler {
  airbrake: Notifier;
  constructor(
    private settingsService: SettingsService
  ) {

    let airbrakeEnv = 'development';
    if (!isDevMode()) {
      if (environment.initialApiUrl === 'https://staging.mcc.software') {
        airbrakeEnv = 'staging';
      } else {
        airbrakeEnv = 'production';
      }
    }

    this.airbrake = new Notifier({
      projectId: 1,
      projectKey: environment.errbitKey,
      host: environment.errbitHost,
      environment: airbrakeEnv
    });

    this.airbrake.addFilter((notice) => {
      if (isDevMode()) {
        return null;
      }
      return notice;
    });
  }

  async handleError(error: any): Promise<void> {
    if (error.toString().toLowerCase().includes('worker was terminated') ||
      error.toString().toLowerCase().includes('barcode scanner')) {
      return;
    }
    const user = await this.settingsService.getCurrentUser();
    const roles = await this.settingsService.getUserRoles();
    const sanitizedError = {
      message: error.message || error.toString(),
      stack: error.stack,
      name: error.name,
      context: {
        user: {
          id: user?.id,
          username: user?.username,
          name: (user?.name?user?.name:user?.firstName) + ' ' + user?.lastName,
          email: user?.email,
          client_name: user?.client_name,
          roles: roles,
        }
      }
    };
    
    this.airbrake.notify(sanitizedError);
  }
}
